import "./DesktopFileItem.scss";
import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { thumbnail, errorPlaceholder } from "../../../functions/thumbnail";
import i18n from "../../../functions/i18next";
import { download } from "../../../functions/download";
import uniqid from "uniqid";
import { userHasAllRights } from "../../../functions/userRights";
import VueLoadImage from "vue-load-image";
import { copyItem } from "../../../functions/copyPaste";
import { addLeadingZero } from "../../../functions/HelperFuncs";

export default {
  props: {
    isPlaceholder: Boolean,
    activeView: String,
    itemData: Object,
    isSearch: Boolean,
  },
  components: {
    "vue-load-image": VueLoadImage,
  },
  data() {
    return {
      id: this.$options.name,
      search: "fix me",
      //checked: false,
      shift: false,
      actions: {},
      activeActions: "file",
      fileId: this.$route.params.file,
      imgLoaded: false,
      fastLoaded: false,
      startLoad: 0,
      loadThreshold: 150,
    };
  },
  created() {
    this.startLoad = new Date();
    //set init actions
    this.setActions();

    if (this.itemData) {
      this.checked = this.itemData.checked;
    }

    this.setNewExtension();

    this.selectMe();
  },
  mounted() {
    this.setIdAttribute();
  },

  methods: {
    isEmbedUrl() {
      return (
        this.itemData.extension === ".url" &&
        this.itemData.location.match(
          /https:\/\/([\w\.-]+\.)?figma.com\/(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/
        )
      );
    },

    setNewExtension() {
      if (this.itemData.extension === ".url") {
        if (
          this.itemData.location.match(
            /https:\/\/([\w\.-]+\.)?figma.com\/(file|proto)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/
          )
        ) {
          this.itemData.extension = ".figma";
        }
      }
    },
    setDate() {
      let date = "";

      if (this.itemData.updated_at) {
        date = this.itemData.updated_at;
      } else if (this.itemData.modified) {
        const dateOBJ = new Date(this.itemData.modified);

        date = `${addLeadingZero(dateOBJ.getDate())}/${addLeadingZero(
          dateOBJ.getMonth() + 1
        )}/${dateOBJ.getFullYear()}`;
      }

      return date;
    },
    onImgLoad() {
      const currentLoad = new Date();

      if (currentLoad.getTime() - this.startLoad.getTime() <= 150) {
        this.fastLoaded = true;
      }

      this.imgLoaded = true;
      EventBus.$emit(`file-list-layout`);
      EventBus.$emit(`desktop-file-list-layout`);
    },
    setSelected(e) {
      const status = e.currentTarget.checked;

      EventBus.$emit("desktop-file-item--checkItem", {
        status,
        file: this.itemData,
      });
    },
    selectMe() {
      const selectOptions = [
        ...this.$store.state.transferItems.selectedFiles,
        ...this.$store.state.transferItems.selectedFolders,
      ];

      let needsSelecting = false;

      selectOptions.forEach((item) => {
        if (item.id === this.itemData.id) {
          needsSelecting = true;
        }
      });

      this.checked = needsSelecting;
    },
    openContextMenu(e) {
      e.preventDefault();

      this.setActions();

      EventBus.$emit(`${this.id}--contextMenu`, {
        e,
        actions: this.getCurrentActions(),
      });
    },
    thumb(item, big = false) {
      return thumbnail(item, big);
    },
    onError(e) {
      errorPlaceholder(e);
    },
    setChecked(checked) {
      this.checked = checked;
    },
    setShift(e) {
      this.shift = e.shiftKey;
    },

    needRightSibarClosed() {
      let itemCount = 0;
      const holders = this.$store.state.transferItems;

      Object.keys(holders).forEach((key) => {
        if (Array.isArray(holders[key])) {
          holders[key].forEach((item) => {
            itemCount++;
          });
        }
      });

      return itemCount <= 2;
    },
    itemPresent(tempItems) {
      return (
        tempItems.filter((item) => item.id === this.itemData.id).length > 0
      );
    },
    getSelectedKey() {
      let key = "selectedFiles";

      if (!this.itemData.extension) {
        key = "selectedFolders";
      }

      return key;
    },
    openFolder() {
      //is a space

      this.$router.push(
        `/${this.$store.state.company}/${
          this.itemData.myspace ? "myspace" : "home"
        }/expanded/${this.itemData.id}`
      );
    },
    openFile(e) {
      e.preventDefault();

      //close previous windows
      if (!this.$route.params.file) {
        EventBus.$emit("closeallactions");
      }

      // open side nav item
      this.$axios
        .get(
          `${baseUrl}/file?file=${
            this.itemData.file_id ? this.itemData.file_id : this.itemData.id
          }&myspace=${this.itemData.myspace}`,
          {
            responseType: "json",
          }
        )
        .then((r) => {
          EventBus.$emit(`right-sidebar-show`, {
            id: "file",
            data: r.data,
          });
        });
    },
    openLink(e) {
      e.preventDefault();
      //check if figma link
      if (this.isEmbedUrl()) {
        //is figma link
        this.openFile(e, this.itemData.id);
      } else {
        //open link in other tab
        const a = document.createElement("a");
        a.target = "_blank";
        a.href = this.itemData.location;
        a.click();
      }
    },
    setActions() {
      if (this.itemData) {
        this.actions = {
          file: [
            this.itemData.extension === ".png" ||
            this.itemData.extension === ".jpg"
              ? {
                  name: i18n.t("files.use_on_homescreen"),
                  icon: "home",
                  rights: ["Administrator"],
                  func: () => {
                    this.addToHomeScreen();
                  },
                }
              : {},
            {
              name: i18n.tc("common.download", 1),
              icon: "download",
              rights: ["download_files", "download_folders"],
              func: () => {
                this.downloadFile();
              },
            },
            {
              name: i18n.t("common.notify"),
              icon: "notify",
              rights: ["notify_files", "notify_folders"],
              func: () => {
                this.openRightSidebar("notify");
              },
            },
            this.itemData
              ? !this.itemData.extension
                ? {
                    name:
                      this.itemData.private === 1
                        ? i18n.t("files.make_public")
                        : i18n.t("files.make_private"),
                    icon: this.itemData.private === 1 ? "lock--open" : "lock",
                    rights: ["make-private_folders"],
                    func: (e) => {
                      this.makePrivate();
                    },
                  }
                : {}
              : {},

            {
              name: i18n.t("common.move"),
              icon: "move",
              rights: ["move_files", "move_folders"],
              func: () => {
                this.openRightSidebar("move");
              },
            },
            {
              name: i18n.t("common.rename"),
              icon: "rename",
              rights: ["rename_files", "rename_folders"],
              func: () => {
                this.openRightSidebar("rename");
              },
            },

            {
              name: i18n.t("transfer.transfer"),
              icon: "transfer",
              rights: ["transfer_files", "transfer_folders"],
              func: () => {
                this.openRightSidebar("transfer");
              },
            },
            {
              name: i18n.t("common.copy"),
              icon: "copy",
              rights: ["copy+paste"],
              func: () => {
                this.copyFile();
              },
            },
            {
              name: i18n.t("common.delete"),
              icon: "delete",
              rights: ["delete_files", "delete_folders"],
              func: () => {
                this.openRightSidebar("delete");
              },
            },
          ],
          collection: [
            {
              name: i18n.t("common.remove"),
              icon: "delete",
              rights: ["collect"],
              func: () => {
                this.openRightSidebar("deleteCollectionItem", {
                  collectionId: this.$route.params.id,
                });
              },
            },
          ],
        };
      } else {
        //is placeholder so no actions
        this.actions = {};
      }

      //detect if
      if (this.$route.path.includes("collection")) {
        //is collection
        this.activeActions = "collection";
      } else {
        this.activeActions = "file";
      }
    },
    getCurrentActions() {
      if (this.actions[this.activeActions]) {
        return this.actions[this.activeActions].filter((action) => {
          if (action.rights) {
            return userHasAllRights(action.rights, this);
          }
          return true;
        });
      }
      return [];
    },
    copyFile() {
      /*let clipboard = {};

      //clear current
      localStorage.setItem(this.$store.state.company + "_" + "clipboard", "");

      if (this.itemData.extension) {
        clipboard.files = [this.itemData];
        clipboard.folders = [];
      } else {
        clipboard.files = [];
        clipboard.folders = [this.itemData];
      }

      localStorage.setItem(
        this.$store.state.company + "_" + "clipboard",
        JSON.stringify(clipboard)
      );

      //send snackbar
      EventBus.$emit(`snackbar--add`, {
        title: `${this.itemData.name ? this.itemData.name : ""} ${i18n.t(
          "common.copied"
        )}`,
        icon: "copy",
        timeout: 3000,
      });*/

      copyItem(this, this.itemData);
    },

    downloadFile() {
      download(
        {
          type: this.itemData.extension ? "file" : "folder",
          item: this.itemData,
        },
        this
      );
    },
    addToHomeScreen() {
      const formData = new FormData();
      formData.append("id", this.itemData.id);
      const myId = uniqid();

      EventBus.$emit(`snackbar--add`, {
        id: myId,
        title: `${i18n.t("common.processing")}...`,
        noTimer: true,
      });

      this.$axios
        .post(`${baseUrl}/sethomescreen`, formData)
        .then((response) => {
          //send snackbar
          EventBus.$emit(`snackbar--remove`, myId);

          EventBus.$emit(`snackbar--add`, {
            title: `${this.itemData.name ? this.itemData.name : ""} ${i18n.t(
              "common.added_to_homescreen"
            )}`,
            icon: "home",
            timeout: 3000,
          });
        });
    },
    makePrivate() {
      const formData = new FormData();
      formData.append("folder", this.itemData.id);
      formData.append("myspace", this.itemData.myspace);
      this.$axios
        .post(baseUrl + "/folderprivate", formData)
        .then((response) => {
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);
        });
    },
    closeRightSidebar() {
      EventBus.$emit(`closeallactions`);
    },
    openRightSidebar(id, extraData = {}) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: { ...this.itemData, ...extraData },
      });
    },
    setIdAttribute() {
      if (this.$el && this.itemData) {
        this.$el.setAttribute("data-id", this.itemData.id);
      }
    },
  },
  watch: {
    $route() {
      this.fileId = this.$route.params.file;
      this.setActions();
      this.selectMe();
    },
    fileId() {},
    actions() {},
    itemData() {
      this.setActions();
      this.setIdAttribute();
      this.selectMe();
    },
    "$store.state.transferItems"() {
      this.selectMe();
    },
  },
};
